package app.nestbridge.domain.identity.api

import app.nestbridge.app.di.ClientApiConfig
import app.nestbridge.domain.identity.api.model.UserDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.isSuccess
import io.ktor.http.contentType
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class RemoteUserApiClient(
    private val httpClient: HttpClient,
    private val config: ClientApiConfig,
) : UserApiClient {

    private val baseUrl get() = "${config.identityServiceUrl}/user"

    override suspend fun fetchCurrent(): UserDto? {
        val response: HttpResponse = httpClient.get("$baseUrl/me")
        return when (response.status) {
            HttpStatusCode.OK -> response.body()
            HttpStatusCode.NotFound -> null
            else -> error("Unexpected response fetching current user: ${response.status}")
        }
    }

    override suspend fun save(user: UserDto): UserDto {
        val response = httpClient.put("$baseUrl/me") {
            contentType(ContentType.Application.Json)
            setBody(user)
        }
        if (!response.status.isSuccess()) {
            error("Failed to save user (${response.status}): ${response.bodyAsText()}")
        }
        return response.body()
    }
}
